<template>
  <InputRow v-model="selectedIds" name="Flags">
    <LISASelect
      v-model="selectedIds"
      class="w-100"
      hide-label
      multiple
      selection-display="chips"
      :options="selectOptions"
    />
  </InputRow>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { useTranslation } from "@/language/translation";

import InputRow from "@/components/shared/form/InputRow.vue";
import { computed, inject, onMounted, ref, watch } from "vue";
import { LISASelect, type LISASelectOption } from "@fi-solutions/lisa-ui";
import FlagsFilter from "../filterImplementations/FlagsFilter";
import { FlagTypes } from "@/graphql";
import { BoardFilterOptionsInjectionKey } from "../FilterTypes";

export type OptionType = {
  id: number;
  name: string;
  color?: string;
  count?: number;
  type?: string;
  systemFlag?: boolean;
  abbreviationId?: number;
  displayNameId?: number;
};

defineEmits(["hide"]);
const boardFilterOptions = inject(BoardFilterOptionsInjectionKey);
const options = computed(() => boardFilterOptions?.options.value.flags ?? []);
const selectedIds = ref<number[]>([]);
const selectOptions = computed<LISASelectOption[]>(() =>
  options.value.map((option) => ({
    id: option.id,
    label: `${flagName(option)} [${t("global.id")}: ${option.id}${option.type === FlagTypes.mailDistribution ? " 📧" : ""}] [${option.count ?? 0}x]`,
    color: option.color ?? "rgb(65, 184, 131)",
  })),
);

function flagName(option: OptionType) {
  if (option.displayNameId != null && te(`dynamic.${option.displayNameId}`)) {
    return t(`dynamic.${option.displayNameId}`).toString();
  }
  if (option.abbreviationId != null && te(`dynamic.${option.abbreviationId}`)) {
    return t(`dynamic.${option.abbreviationId}`).toString();
  }
  return option.name;
}

async function loadOptions() {
  await boardFilterOptions?.load();
}

onMounted(loadOptions);
watch(() => boardFilterOptions?.queryKey.value, loadOptions);
function getFilter() {
  return selectedIds.value.length === 0 ? null : new FlagsFilter(selectedIds.value);
}

function applyFilter(filter: FlagsFilter) {
  selectedIds.value = filter.flagIds;
}
defineExpose({
  getFilter,
  applyFilter,
});

const { t, te } = useTranslation();
</script>

<style lang="scss" scoped>
span {
  margin-left: 0.2em;
}
</style>
